import { useRouter } from '@tanstack/react-router';
import { Button } from '@workspace/ui/components/button';
import { ArrowLeft } from 'lucide-react';
import { useEffect } from 'react';
import { type Breadcrumb, useLayout } from '~/context/layout/layout-context';

export interface LayoutProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  goBack?: boolean;
  breadcrumbs?: Breadcrumb[];
}

export function Layout({
  title,
  subtitle,
  children,
  goBack = false,
  breadcrumbs,
}: LayoutProps) {
  const { setPageTitle, setBreadcrumbs } = useLayout();

  const router = useRouter();

  const handleGoBack = () => {
    router.history.back();
  };

  useEffect(() => {
    setPageTitle(title);
    setBreadcrumbs(breadcrumbs || []);
  }, [title, breadcrumbs, setPageTitle, setBreadcrumbs]);

  return (
    <div className="bg-background text-white container mx-auto">
      <header className="py-4.5">
        <div className="flex items-center gap-3 ml-13 mr-4">
          {goBack && (
            <Button
              variant="ghost"
              onClick={handleGoBack}
              className="h-8 w-8 cursor-pointer shrink-0 relative z-20"
            >
              <ArrowLeft className="h-4 w-4" />
            </Button>
          )}
        </div>
        <div className="flex-1">
          {/* <h1 className="text-lg font-medium">{title}</h1> */}
          {subtitle && <p className="text-muted-foreground mt-1">{subtitle}</p>}
        </div>
      </header>
      <div className="p-4">{children}</div>
    </div>
  );
}
